import React, { useState } from 'react';
import { Column, TableData } from '../components/TableData';

// Sample data type
interface User {
  id: number;
  name: string;
  email: string;
  age: number;
  role: string;
}

// Sample data
const sampleData: User[] = [
  {
    id: 1,
    name: 'John Doe',
    email: 'john@example.com',
    age: 30,
    role: 'Admin',
  },
  {
    id: 2,
    name: 'Jane Smith',
    email: 'jane@example.com',
    age: 25,
    role: 'User',
  },
  {
    id: 3,
    name: 'Bob Johnson',
    email: 'bob@example.com',
    age: 40,
    role: 'Editor',
  },
];

// Column definitions
const columns: Column<User>[] = [
  {
    id: 'id',
    label: 'ID',
    align: 'center',
  },
  {
    id: 'name',
    label: 'Name',
    minWidth: 150,
    align: 'left',
    link: true,
    getLink: (row) => `/user/${row.id}`,
    format: (value: string) => <strong>{value}</strong>,
  },
  {
    id: 'email',
    label: 'Email',
    align: 'left',
    allowTextWrap: true,
  },
  {
    id: 'age',
    label: 'Age',
    align: 'center',
    format: (value: number) => `${value} years`,
  },
  {
    id: 'role',
    label: 'Role',
    align: 'center',
    render: (row) => (
      <span style={{ color: row.role === 'Admin' ? 'green' : 'blue' }}>
        {row.role}
      </span>
    ),
  },
];

const TableDemo: React.FC = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState<User[]>(sampleData);
  const [isLoading, setIsLoading] = useState(false);

  const handlePageChange = (newPage: number, newRowsPerPage: number) => {
    setPage(newPage);
    setRowsPerPage(newRowsPerPage);
    // Simulate fetching data
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  const handleEdit = (row: User) => {
    console.log('Edit row:', row);
    // Implement edit logic here
  };

  const handleDelete = (row: User) => {
    console.log('Delete row:', row);
    setData(data.filter((item) => item.id !== row.id));
  };

  return (
    <TableData
      columns={columns}
      data={data}
      total={data.length}
      page={page}
      rowsPerPage={rowsPerPage}
      isLoading={isLoading}
      showActionCell={true}
      onEdit={handleEdit}
      onDelete={handleDelete}
      onPageChange={handlePageChange}
    />
  );
};

export default TableDemo;
